import { isString } from '@/libs/utils'

const TEL_REGEX = /^\d{2,3}-?\d{3,4}-?\d{4}$/
const EMAIL_REGEX = /([\w-]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/
const URL_REGEX = /(http|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:/~+#-]*[\w@?^=%&amp;/~+#-])?/
const IP_SIMPLE_REGEX = /^[\x21-\x7E]*$/
const IPV4_REGEXP = /^([01]?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])\\.([01]?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])\\.([01]?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])\\.([01]?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])$/
const IPV6_REGEXP = /^((?:[0-9A-Fa-f]{1,4}))((?::[0-9A-Fa-f]{1,4}))*::((?:[0-9A-Fa-f]{1,4}))((?::[0-9A-Fa-f]{1,4}))*|((?:[0-9A-Fa-f]{1,4}))((?::[0-9A-Fa-f]{1,4})){7}$/
const CUSTOM_ID_REGEXP = /^[a-zA-Z._-]+$/

export function isCustomIdCheck (value) {
  return CUSTOM_ID_REGEXP.test(value)
}

export function isValidUrl (value) {
  if (!isString(value)) {
    return false
  }
  value = value.trim()
  return URL_REGEX.test(value)
}

export function isValidRegex (value) {
  if (!isString(value)) {
    return false
  }
  value = value.trim()

  if (value.charAt(0) === '/' && value.charAt(value.length - 1) === '/') {
    value = value.slice(1, -1)
  }

  try {
    // eslint-disable-next-line no-unused-vars
    const regex = new RegExp(value)
  } catch (err) {
    return false
  }
  return true
}

export function isValidTel (value) {
  if (!isString(value)) {
    return false
  }
  value = value.trim()
  return TEL_REGEX.test(value)
}

export function isValidEmail (value) {
  if (!isString(value)) {
    return false
  }
  value = value.trim()
  return EMAIL_REGEX.test(value)
}

export function isValidIpAddress (value) {
  if (!isString(value)) {
    return false
  }
  value = value.trim()
  return IP_SIMPLE_REGEX.test(value)
}

export function isIpv4Address (value) {
  if (!isString(value)) {
    return false
  }
  value = value.trim()
  return IPV4_REGEXP.test(value)
}

export function isIpv6Address (value) {
  if (!isString(value)) {
    return false
  }
  value = value.trim()
  return IPV6_REGEXP.test(value)
}
